import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DoubleCounter from 'components/shared/counters/double/DoubleCounter';
import Emoji from 'components/shared/Emoji';
import routes from 'common/routes';

function MembershipStatusCounters() {
  const { t } = useTranslation(['labels']);
  const navigate = useNavigate();

  const activeClientsCounter = useSelector((state) => state.client.counters.active);
  const inactiveClientsCounter = useSelector((state) => state.client.counters.inactive);

  return (
    <DoubleCounter
      emoji={<Emoji label={t('membershipStatus', { ns: 'labels' })} symbol="🎫" />}
      title={t('membershipStatus', { ns: 'labels' })}
      onClick={() => navigate(routes.listClient.path)}
      counters={[
        {
          title: `${t('membershipStatus.active', { context: 'female', ns: 'options' })}s`,
          counter: activeClientsCounter
        },
        {
          title: `${t('membershipStatus.inactive', { context: 'female', ns: 'options' })}s`,
          counter: inactiveClientsCounter
        }
      ]}
    />
  );
}

export default MembershipStatusCounters;
